export { MapAlt as default } from './MapAlt';
